import { createBrowserRouter } from 'react-router';
import MainLayout from '../components/layout/main-layout';

// Page component imports
import RoomList from '../pages/rooms/room-list';
import RoomDetail from '../pages/rooms/room-detail';
import ExhibitList from '../pages/exhibits/exhibit-list';
import ExhibitDetail from '../pages/exhibits/exhibit-detail';
import ScanPage from '../pages/scan';
import EnhancedScanPage from '../pages/scan/enhanced-scan';
import SettingsPage from '../pages/settings'; // Import the actual settings page
import UnderDevelopmentPlaceholder from '../components/molecules/under-development-placeholder'; // Import the placeholder
import AboutPage from '../pages/about'; // Import the actual About page
import HomePage from '../pages/home'; // Import the actual Home page
import MapPage from '../pages/map'; // Import the actual Map page

// Placeholder components
// Removed Home, Tours, and About placeholders
// Removed placeholder Settings component
const NotFound = () => (
    <div className="page not-found-page">
        <h1>Page Not Found</h1>
    </div>
);
const TourDetail = () => (
    <div className="page tour-detail-page">
        <h1>Tour Detail</h1>
    </div>
);

/**
 * Routes configuration for the museum app
 * - Creates a browser router with all application routes
 * - All routes are wrapped in the MainLayout component
 * - Provides fallback for 404 pages
 */
const appRouter = createBrowserRouter([
    {
        path: '/',
        element: <MainLayout children={undefined} />,
        children: [
            { path: '/', element: <HomePage /> },
            { path: '/rooms', element: <RoomList /> },
            { path: '/exhibits', element: <ExhibitList /> },
            { path: '/tours', element: <UnderDevelopmentPlaceholder pageName="Tours" /> },
            // Use the enhanced scan page as the default scan page
            { path: '/scan', element: <EnhancedScanPage /> },
            // Keep the original scan page available at a different URL for backward compatibility
            { path: '/scan/legacy', element: <ScanPage /> },
            { path: '/map', element: <MapPage /> }, // Use actual MapPage
            { path: '/about', element: <AboutPage /> },
            { path: '/settings', element: <SettingsPage /> },
            { path: '/rooms/:id', element: <RoomDetail /> },
            { path: '/exhibits/:id', element: <ExhibitDetail /> },
            { path: '/tours/:id', element: <TourDetail /> },
            { path: '*', element: <NotFound /> },
        ],
    },
]);

export default appRouter;
